import React, { Component } from 'react';
import PropTypes from 'prop-types';

import styled from 'styled-components';

import { Box } from '../../../../../units/Box/Box';
import Text from '../../../../../units/Text/Text';
import Icon from '../../../../../units/Icon/Icon';

const Item = styled(Box)`
  color: ${props =>
    props.active ? props.theme.colors.brand : props.theme.colors.black};
  transition: background-color 200ms ease-in;
  cursor: pointer;
  padding: 6px 11px 15px;
  border-bottom: 1px solid #cdcdcd;

  &:last-child {
    border-bottom: 0;
  }

  &:hover {
    background-color: rgba(0, 120, 84, .5);
    transition: background-color 0ms ease-in;
  }
`;

const OrgName = styled(Text).attrs({
  bold: true,
  size: '14px',
  lineHeight: '18px'
})`
  text-transform: uppercase;
`;

const OrgKpp = styled(Text).attrs({
  size: '13px',
  font: 'caption'
})``;

const OrgAddress = styled(Text).attrs({
  size: '13px',
  font: 'caption',
  color: '#737373'
})``;

const Label = styled(Box)``;

class OrgsDropdownItem extends Component {
  static propTypes = {
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    item: PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
      name: PropTypes.string.isRequired,
      kpp: PropTypes.string.isRequired,
      address: PropTypes.string.isRequired
    }).isRequired,
    onChange: PropTypes.func
  };

  static defaultProps = {
    value: null,
    onChange: null
  };

  onChange = () => {
    if (!this.props.onChange) return;
    this.props.onChange(this.props.item.value);
  };

  render() {
    return (
      <Item
        active={this.props.item.value === this.props.value}
        onClick={this.onChange}
        className="dropdown-item"
      >
        <Label>
          <Box>
            <OrgName>{this.props.item.name}</OrgName>
          </Box>
          <Box mt="5px">
            <OrgKpp>{`КПП ${this.props.item.kpp}`}</OrgKpp>
          </Box>
          <Box mt="4px">
            <Icon width="10px" height="14px" />
            <OrgAddress>{this.props.item.address}</OrgAddress>
          </Box>
        </Label>
      </Item>
    );
  }
}

export default OrgsDropdownItem;



// WEBPACK FOOTER //
// ./src/components/containers/Forms/FormsComponents/RegistratUserOrgResult/OrgsDropdownItems/OrgsDropdownItem.js